import axios from "axios";
import { API } from "@/lib/api";

const CONSENT_KEY = "sc_cookie_consent"; // 'accepted' | 'rejected'
const VISITOR_KEY = "sc_visitor_id";

export const getConsent = () => localStorage.getItem(CONSENT_KEY);
export const setConsent = (v) => localStorage.setItem(CONSENT_KEY, v);
export const clearConsent = () => localStorage.removeItem(CONSENT_KEY);
export const hasAnalyticsConsent = () => getConsent() === "accepted";

// A visitor id is only ever created once the user has accepted analytics cookies.
function visitorId() {
  let v = localStorage.getItem(VISITOR_KEY);
  if (!v) {
    v =
      window.crypto && window.crypto.randomUUID
        ? window.crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(VISITOR_KEY, v);
  }
  return v;
}

// Fire-and-forget. Does NOTHING unless the user accepted analytics cookies,
// so no non-essential cookie/identifier is set without consent.
export async function track(event, path) {
  if (!hasAnalyticsConsent()) return;
  try {
    await axios.post(`${API}/track`, {
      visitor_id: visitorId(),
      event,
      path: path || window.location.pathname,
      referrer: document.referrer || "",
    });
  } catch (err) {
    if (process.env.NODE_ENV !== "production") {
      // analytics must never block the app; surface only in dev
      console.error("track() failed", err);
    }
  }
}

export const COOKIE_SETTINGS_EVENT = "sc:cookie-settings";
export const openCookieSettings = () =>
  window.dispatchEvent(new Event(COOKIE_SETTINGS_EVENT));
